import emergency from '../Assets/Features/emergency.png';
import appoitment from '../Assets/Features/appoitment.png';
import healthcare from '../Assets/Features/healthcare.png';

export const FakeFeatures = [
    {
        "id": "002",
        "title": "Emergency Service",
        "description": "24/7 Emergency Physiotherapy Care: Our dedicated team is here to provide immediate support and relief when you need it most.",
        "img": emergency
    },
    {
        "id": "001",
        "title": "Easy Appointment",
        "description": "Simplify Your Care: Book appointments effortlessly, ensuring prompt access to expert physiotherapy services tailored to your needs.",
        "img": appoitment
    },
    {
        "id": "003",
        "title": "24/7 Service",
        "description": "Round-the-Clock Care: We're here for you 24/7, providing continuous physiotherapy support to help you recover and thrive at any hour.",
        "img": healthcare
    }
]


